import { getQueryParameter, getWindowLocation } from '@iwRouter/LocationHelper';
import _ from 'lodash';
import { fork, put, take, takeLatest } from 'redux-saga/effects';

import {
    ACTIVATE_ID_CHECK_VERIFICATION,
    ADD_PHONE_NUMBER,
    ID_CHECK_VERIFICATION_DATA,
    ID_CHECK_MAXIMUM_ATTEMPTS,
    PHONE_NUMBER_VALIDATION_ERROR,
    SEND_VERIFICATION_SMS,
    SEND_VERIFICATION_SMS_FAIL,
    SEND_VERIFICATION_SMS_PENDING,
    SEND_VERIFICATION_SMS_SUCCESS,
    TOGGLE_ADD_PHONE_NUMBER
} from './IdCheckVerificationModal.actions';
import {
    buildOnfidoMessagesSent,
    hasIDVerseSplitTest,
    isValid,
    serialisePersonState
} from './IdCheckVerificationModalHelper';
import { putAndWaitAPI, selectAPI } from '../../../api/API.sagas';
import {
    API_GET_CUSTOMER_STATE_EDIT,
    API_POST_ONFIDO_SMS,
    API_POST_ONFIDO_SMS_FAIL,
    API_POST_ONFIDO_SMS_SUCCESS,
    API_POST_ID_CHECK_SMS,
    API_POST_ID_CHECK_SMS_FAIL,
    API_POST_ID_CHECK_SMS_SUCCESS,
    API_SAVE_CUSTOMER_STATE,
    API_SAVE_CUSTOMER_STATE_SUCCESS,
    API_GET_FUNDING_REQUIREMENT_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { OPEN_MODAL } from '../../../iwModals/Modals.actions';
import { getFundingRequirements } from '../../funding/fundingSteps/FundingSteps.sagas';

export const idCheckVerificationWorkers = [
    fork(idCheckVerificationWorker),
    fork(sendSMSWorker),
    fork(addPhoneNumberWorker)
];

function* idCheckVerificationWorker() {
    yield takeLatest(ACTIVATE_ID_CHECK_VERIFICATION, function* () {
        yield put({ type: OPEN_MODAL, id: 'IdCheckVerificationModal' });

        const { customer_state, funding_requirement, site_context } =
            yield selectAPI();
        yield put({
            type: ID_CHECK_VERIFICATION_DATA,
            customer_state,
            funding_requirement,
            site_context
        });
    });
}

function* sendSMSWorker() {
    yield takeLatest(SEND_VERIFICATION_SMS, function* (action) {
        yield put({
            type: SEND_VERIFICATION_SMS_PENDING,
            personUID: action.person.uid
        });
        const phoneEntry = _.find(action.person.phones, {
            value: action.phoneNumber
        });
        const data = {
            data: {
                person_uid: action.person.uid,
                phone_uid: phoneEntry.uid
            }
        };

        const { site_context } = yield selectAPI();
        let isIDVerseSplitTest = hasIDVerseSplitTest(site_context);
        if (isIDVerseSplitTest) {
            const location = getWindowLocation();
            const offerId = getQueryParameter(location, 'offerId');
            data.data.redirect_url = location.href;
            data.data.offer_id = offerId;
        }

        const { customer_state } = yield selectAPI();
        const previousOnfidoSMSMessagesSent =
            customer_state?.ui?.draw_down?.sms_verification_messages_sent;
        let api_post_id_check_action = isIDVerseSplitTest
            ? API_POST_ID_CHECK_SMS
            : API_POST_ONFIDO_SMS;
        const nextAction = yield putAndWaitAPI({
            type: api_post_id_check_action,
            body: JSON.stringify(data)
        });
        switch (nextAction.type) {
            case API_POST_ID_CHECK_SMS_SUCCESS:
            case API_POST_ONFIDO_SMS_SUCCESS:
                yield put({
                    type: 'api/UPDATE_DRAW_DOWN_STATE',
                    smsVerificationMessagesSent: buildOnfidoMessagesSent(
                        previousOnfidoSMSMessagesSent,
                        action.person.uid
                    )
                });
                yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);
                yield put({
                    type: SEND_VERIFICATION_SMS_SUCCESS,
                    personUID: action.person.uid
                });

                yield* getFundingRequirements();

                const { response } = yield take(
                    API_GET_FUNDING_REQUIREMENT_SUCCESS
                );

                if (response.status === 400) {
                    yield put({
                        type: ID_CHECK_MAXIMUM_ATTEMPTS,
                        personUID: action.person.uid
                    });
                    break;
                }

                const { customer_state, funding_requirement, site_context } =
                    yield selectAPI();

                yield put({
                    type: ID_CHECK_VERIFICATION_DATA,
                    customer_state,
                    funding_requirement,
                    site_context
                });
                break;

            case API_POST_ID_CHECK_SMS_FAIL:
            case API_POST_ONFIDO_SMS_FAIL:
                yield put({
                    type: SEND_VERIFICATION_SMS_FAIL,
                    personUID: action.person.uid
                });
                break;
        }
    });
}

function* addPhoneNumberWorker() {
    yield takeLatest(ADD_PHONE_NUMBER, function* (action) {
        if (!isValid(action.person.newPhoneNumber)) {
            return yield put({
                type: PHONE_NUMBER_VALIDATION_ERROR,
                personUID: action.person.uid
            });
        }

        const { customer_state } = yield selectAPI();
        const people = customer_state?.application?.people;
        const newPersonState = serialisePersonState(people, action.person);
        yield saveFormAndClose(action.person.uid, newPersonState);
    });
}

function* saveFormAndClose(personUID, people) {
    yield put({
        type: API_GET_CUSTOMER_STATE_EDIT,
        data: {
            application: {
                people: people
            }
        }
    });

    yield put({ type: API_SAVE_CUSTOMER_STATE });
    yield take(API_SAVE_CUSTOMER_STATE_SUCCESS);

    const { customer_state, funding_requirement, site_context } =
        yield selectAPI();
    yield put({ type: TOGGLE_ADD_PHONE_NUMBER, personUID });
    yield put({
        type: ID_CHECK_VERIFICATION_DATA,
        customer_state,
        funding_requirement,
        site_context
    });
}
